/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
interface useJobCreateMaxExceeded {
  allRowsSelected?: boolean;
  rowCount?: number;
  selectedCount?: number;
};

const MAX_DEVICES_SELECTED = 50000;

/**
 * React Hook to provide utility for Job Create Maximun Limit Exceeded functionality.
 *
 *  ```typescript
 *   import {useJobCreateMaxExceeded} from '@ion/applications/src/components/jobs';
 *
 *   const {maxLength, isMaxExceeded} = useJobCreateMaxExceeded({
 *     allRowsSelected,
 *     rowCount,
 *     selectedCount
 *   });
 *
 *  ```
 */
export const useJobCreateMaxExceeded = ({
  allRowsSelected,
  rowCount,
  selectedCount
}: useJobCreateMaxExceeded) => {
  const isMaxExceeded = (
    (allRowsSelected && rowCount > MAX_DEVICES_SELECTED) ||
     selectedCount > MAX_DEVICES_SELECTED
  );
  return {
    maxLength : MAX_DEVICES_SELECTED,
    isMaxExceeded
  };
};

export default useJobCreateMaxExceeded;
